import PropTypes from "prop-types";
import AppDialog, {
  AppDialogCancelButton,
  AppDialogConfirmButton,
} from "common/Components/AppDialog";

const CustomAlert = ({
  title,
  show,
  cancelText = "Cancel",
  okText = "Ok",
  message,
  onCancel,
  onOkay,
  buttonVariant = "default",
}) => {
  const hasActions = Boolean(onCancel || onOkay);

  return (
    <AppDialog
      open={Boolean(show)}
      onClose={onCancel ?? undefined}
      disableEscapeKeyDown={!onCancel}
      aria-labelledby="custom-alert-dialog-title"
      heading={title}
      sx={{ zIndex: 1500 }}
      data-testid="custom-alert-dialog"
      data-button-variant={buttonVariant}
      footer={
        hasActions ? (
          <>
            {onCancel ? (
              <AppDialogCancelButton variant="outlined" onClick={onCancel}>
                {cancelText}
              </AppDialogCancelButton>
            ) : null}
            {onOkay ? (
              <AppDialogConfirmButton variant="contained" onClick={onOkay}>
                {okText}
              </AppDialogConfirmButton>
            ) : null}
          </>
        ) : null
      }
    >
      {message}
    </AppDialog>
  );
};

CustomAlert.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool,
  cancelText: PropTypes.string,
  okText: PropTypes.string,
  message: PropTypes.string,
  onCancel: PropTypes.func,
  onOkay: PropTypes.func,
  buttonVariant: PropTypes.oneOf(["default", "pill"]),
};

export default CustomAlert;
